import React, { useState, useEffect } from 'react';

const Login: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.title = 'Login Page - Procedures Chatbot';
  }, []);

  const handleMicrosoftLogin = () => {
    console.log('Login button clicked');
    // Show loading state
    setIsLoading(true);
    
    // Direct redirect to Azure OAuth2
    const currentDomain = window.location.origin;
    const loginUrl = `${currentDomain}/api/auth/login`;
    console.log('Redirecting to:', loginUrl);
    
    // Use immediate redirect instead of setTimeout
    window.location.href = loginUrl;
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(to bottom right, #f9fafb, #f3f4f6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem'
    }}>
      <div style={{ 
        maxWidth: '400px', 
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        {/* Logo and Title */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '2rem',
          width: '100%'
        }}>
          <div style={{ 
            marginBottom: '1.5rem',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <img
              src="/logo.png"
              alt="Ahmed Almazrouei Group L.L.C."
              style={{ 
                height: '80px', 
                width: 'auto',
                display: 'block'
              }}
            />
          </div>
          <h2 style={{ 
            fontSize: '1.875rem', 
            fontWeight: 'bold', 
            color: '#111827',
            margin: '0',
            textAlign: 'center'
          }}>
            Procedures Chatbot
          </h2>
        </div>

        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '1.5rem',
          width: '100%',
          alignItems: 'center'
        }}>
          {/* Microsoft OAuth Login */}
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleMicrosoftLogin();
            }}
            disabled={isLoading}
            type="button"
            style={{
              width: '100%',
              maxWidth: '300px',
              padding: '0.75rem 1.5rem',
              border: 'none',
              borderRadius: '0.5rem',
              fontSize: '1rem',
              fontWeight: '600',
              color: 'white',
              backgroundColor: '#2563eb',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.5 : 1,
              textAlign: 'center',
              transition: 'opacity 0.2s'
            }}
          >
            {isLoading ? 'Signing in...' : 'Sign in تسجيل الدخول'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login; 